import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSelectedSchool,
  setSelectedSchool
} from "../../store/genius/geniusSchool.slice";

export const useSchoolStore = () => {
  const dispatch = useDispatch();
  const selectedSchool = useSelector((state) => state.geniusSchool?.selectedSchool ?? null);

  return {
    selectedSchool,
    setSelectedSchool: useCallback(
      (school) => {
        dispatch(setSelectedSchool(school));
      },
      [dispatch]
    ),
    clearSelectedSchool: useCallback(() => {
      dispatch(clearSelectedSchool());
    }, [dispatch])
  };
};
